import { render, staticRenderFns } from "./productPermSearchModal.vue?vue&type=template&id=52b9df68&scoped=true&"
import script from "./productPermSearchModal.vue?vue&type=script&lang=js&"
export * from "./productPermSearchModal.vue?vue&type=script&lang=js&"
import style0 from "./productPermSearchModal.vue?vue&type=style&index=0&id=52b9df68&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b9df68",
  null
  
)

export default component.exports